/* Emir ICE — refonte 2 univers — comportements GLOBAUX (2026-10-12)
   1. Commutateur d'univers mobile : pastille courante visible, ligne repliée quand on descend, de retour dès qu'on remonte.
   2. Pastille « eix-has-ubar » sur <body> (compense la hauteur de la ligne dans l'en-tête fixe, voir eix-global.css).
   InstantClick remplace le <body> sans recharger la page : tout est ré-initialisé sur l'événement « change », les écouteurs globaux ne sont posés qu'une fois. */
(function () {
  'use strict';
  if (window.__eixGlobal) return;
  window.__eixGlobal = true;

  var html = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 798px)') : { matches: false };
  var lastY = window.pageYOffset || 0;
  var ticking = false;

  function bar() { return document.querySelector('#header .eix-ubar'); }


  /* InstantClick ne remplace que le <body> : si l'on arrive sur l'accueil ou une page d'entrée depuis une autre page,
     la feuille eix-home.css (liée seulement dans le <head> de ces pages) doit être ajoutée ici. */
  function ensureHomeCss() {
    if (!window.__eixCss || !window.__eixCss.home) return;
    if (!document.querySelector('.eix-sec')) return;
    if (document.querySelector('link[data-eix-home]') || document.querySelector('link[href^="' + window.__eixCss.home.split('?')[0] + '"][rel="stylesheet"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = window.__eixCss.home; l.setAttribute('data-eix-home', '1');
    document.head.appendChild(l);
  }

  function init() {
    ensureHomeCss();
    var b = bar();
    if (document.body) document.body.classList.toggle('eix-has-ubar', !!b);
    html.classList.remove('eix-ubar-hide');
    if (!b) return;
    var list = b.querySelector('.eix-ubar__list');
    var cur = b.querySelector('.is-current');
    if (list && cur && cur.parentElement) {
      // pastille courante visible dès l'ouverture (sans animation)
      var left = cur.parentElement.offsetLeft - 12;
      list.scrollLeft = left > 0 ? left : 0;
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      if (!mq.matches) { html.classList.remove('eix-ubar-hide'); return; }
      var y = window.pageYOffset || 0;
      var d = y - lastY;
      if (document.body && document.body.classList.contains('is-active')) { lastY = y; return; } // menu mobile ouvert
      if (Math.abs(d) < 6) return;
      if (y < 90) html.classList.remove('eix-ubar-hide');
      else html.classList.toggle('eix-ubar-hide', d > 0);
      lastY = y;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', init);

  function boot() {
    init();
    if (window.InstantClick && typeof window.InstantClick.on === 'function') {
      window.InstantClick.on('change', function () { lastY = window.pageYOffset || 0; init(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
